import { getOne, getListEmployees, searchBar } from "../../Provider";

export function GetAdviserInfoService(id) {
  return getOne(id);
}

export function GetAdviserListService(zone) {
  return getListEmployees("afiliador", zone);
}

export function GetAdviserListBySearchBarService(zone, name){
  return searchBar("afiliador", zone, name);
}

export function RegisterAdviserService(userModel, password) {
  // const body = { ...userModel, password };
  // return createOne("afiliador", body);
}